module.exports = __webpack_public_path__ + "static/media/img-15.06a84379.png";